import { render, staticRenderFns } from "./matchingResults_nwd.vue?vue&type=template&id=570f8bac&scoped=true"
import script from "./matchingResults_nwd.vue?vue&type=script&lang=js"
export * from "./matchingResults_nwd.vue?vue&type=script&lang=js"
import style0 from "./matchingResults_nwd.vue?vue&type=style&index=0&id=570f8bac&prod&lang=css"
import style1 from "./matchingResults_nwd.vue?vue&type=style&index=1&id=570f8bac&prod&scoped=true&lang=css"
import style2 from "./matchingResults_nwd.vue?vue&type=style&index=2&id=570f8bac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f8bac",
  null
  
)

export default component.exports